import { useMutation, useQueryClient } from '@tanstack/react-query'

import { postRequest } from 'src/lib/api-client'
import { logger } from 'src/lib/logger'
import { queries } from 'src/lib/query-keys'
import type { MyUserDataResponse } from 'src/shared/features/users/schemas/user'

export const registerUserInBackend = async (userData: object): Promise<MyUserDataResponse> => {
  try {
    const response = await postRequest<MyUserDataResponse>('/users/', userData)
    if (!response) {
      throw new Error('No response received from backend registration')
    }
    return response
  } catch (error) {
    logger.error('Error registering user in backend:', error)
    throw error
  }
}

export const useRegisterUserInBackend = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: registerUserInBackend,
    onSuccess: (response: MyUserDataResponse) => {
      // Set user data in cache
      if (response.user) {
        queryClient.setQueryData(queries.users.me.queryKey, response.user)
      }

      // Set tokens in cache
      if (response.tokens) {
        queryClient.setQueryData(queries.users.me._ctx.tokens.queryKey, response.tokens)
      }

      // Still invalidate auth session as it might need a refresh
      queryClient.invalidateQueries({ queryKey: queries.auth._def })
    },
  })
}
